import { throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { ApiService } from '../../core/services/index';

@Injectable({ providedIn: 'root' })
export class usersService {

    constructor(private _api: ApiService) { }

    login(data) {
        return this._api.post(`${"users/login"}`, data)
            .pipe(
                map((res: any) => res),
                catchError((error: any) => throwError(() => error))
            );
    }

    signup(data) {
        return this._api.post(`${"users/signup"}`, data)
            .pipe(
                map((res: any) => res),
                catchError((error: any) => throwError(() => error))
            );
    }   
    
    freeTierSignup(data) {
        console.log('cll hit')
        return this._api.post(`${"users/free-tier-upgrade"}`, data)
            .pipe(
                map((res: any) => res),
                catchError((error: any) => throwError(() => error))
            );
    }   

    getUserById(id:string){
        return this._api.get(`${"users/byId/" + id}`)
            .pipe(
                map((res:any) => res),
                catchError((error: any) => throwError(() => error))
            )
    }

    updateUserById(id:string, data){
        return this._api.put(`${"users/update/" + id}`, data)
            .pipe(
                map((res:any) => res),
                catchError((error: any) => throwError(() => error))
            )
    } 
    
    resetPassword(id:string, data){
        return this._api.put(`${"users/password-update/" + id}`, data)
            .pipe(
                map((res:any) => res),
                catchError((error: any) => throwError(() => error))
            )
    }
    
    forgetPassword(data){
        return this._api.post(`${"users/password-forget"}`, data)
            .pipe(
                map((res:any) => res),
                catchError((error: any) => throwError(() => error))
            )
    }

    resetForgetPassword(data){
        return this._api.post(`${"users/password-forget-reset"}`, data)
            .pipe(
                map((res:any) => res),
                catchError((error: any) => throwError(() => error))
            )
    }
}

